<template>
  <section
    :class="{ 'simulation-collage-history-section': hasSimulationHistory }"
  >
    <PageTitle>
      <span
        class="simulation-collage-history-page-title"
        v-html="$store.state.app.pageName"
      />
    </PageTitle>
    <PageContent v-if="!hasSimulationHistory">
      <Container>
        <NoticeBox type="error"
        :borderless="true"
        class="space-b-2 text-bold"
        >
          現在、見積シミュレーション履歴がありません
        </NoticeBox>
        <p class="text-paragraph text-xs">
          現在表示される見積シミュレーション履歴がありません。
          <br class="mobile-only" />
          見積シミュレーション履歴がある場合は、この画面に表示されます。
        </p>
        <div class="text-center space-t-6">
          <router-link
            :to="$wcRouter.path({ name: 'index' })"
            class="button waves-effect waves-light"
          >
            TOPへ
          </router-link>
        </div>
      </Container>
    </PageContent>
    <PageContent v-else :top-sticked="true">
      <Container>
        <ul class="list-group simulation-collage-history-list-group">
          <li
            class="list-group-item simulation-collage-history-list-group-item"
            v-for="simulationHistory in simulationHistoryList"
            :key="simulationHistory.simulation_history_id"
          >
            <div class="simulation-collage-history-content">
              <div class="simulation-collage-history-item">
                <div class="simulation-collage-history-amount">
                  ¥{{ simulationHistory.amount | numFormat }}
                </div>
                <div class="simulation-collage-history-simulation_date_time">
                  {{ simulationHistory.simulation_date_time | formatDateTime }}
                </div>
                <div class="simulation-collage-history-created_user_name">
                  {{ $domUtils.decode(simulationHistory.created_user_name) }}
                </div>
              </div>
              <div>
                <div
                  class=
                    "simulation-collage-history-button
                    simulation-history-button"
                >
                  <router-link
                    :to="`simulation/${simulationHistory.simulation_history_id}`"
                    class="button waves-effect waves-light"
                  >
                    見積もり詳細
                  </router-link>
                </div>
                <div
                  class="
                    simulation-collage-history-button
                    collage-history-button
                  "
                >
                  <router-link
                    :to="`collage/${simulationHistory.simulation_history_id}`"
                    class="button waves-effect waves-light"
                  >
                    コラージュ
                  </router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </Container>
    </PageContent>
  </section>
</template>
<script>
import NoticeBox from "@/components/NoticeBox.vue"
import simulationHistoryApi from "@/api/simulation-history"
import { renderError } from "@/utils/error"
import { formatDateTime } from "@/filters/format-date"
import numFormat from "@/filters/num-format"

export default {
  components: {
    NoticeBox,
  },
  filters: {
    formatDateTime,
    numFormat,
  },
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: "simulation-collage-history" }
    }
  },
  data() {
    return {
      simulationHistoryList: [],
    }
  },
  computed: {
    hasSimulationHistory() {
      return this.simulationHistoryList.length > 0
    },
    businessId() {
      return this.$store.getters["auth/businessId"]
    },
  },
  methods: {
    async fetchSimulationHistory() {
      try {
        this.simulationHistoryList =
          await simulationHistoryApi.get(this.businessId)
      } catch (err) {
        renderError(err)
      }
    },
  },
  created() {
    this.$withLoading(() => Promise.all([this.fetchSimulationHistory()]))
  },
}
</script>